import { createTheme } from "@mui/material"

// Global MUI theme and style overrides

const theme = createTheme({
  palette: {
    primary: {
      main: "#5865F2",
    },
  },
  typography: {
    fontFamily: '"Noto sans", sans-serif',
    button: {
      textTransform: "none",
      fontSize: 15,
      fontWeight: 500,
    },
  },
})

export default theme
